import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { YouTubeButton } from 'components/SocialButton';
import useYouTubeAuthenticator from 'hooks/useYouTubeAuthenticator';
import { hideModal, pushModal } from 'redux/modules/modal';
import { createChainedFunction } from 'utils/functions';
import useOnDownloadPageAction from '../useOnDownloadPageAction';

const YoutubePostButton: React.FC = () => {
  const [shouldReauthenticate, setShouldReauthenticate] = useState<boolean>(
    false,
  );

  const { onDownloadPageAction } = useOnDownloadPageAction();
  const dispatch = useDispatch();

  const handleError = useCallback(() => {
    setShouldReauthenticate(true);
    dispatch(hideModal());
  }, [dispatch]);

  const { authenticating, withAuthentication } = useYouTubeAuthenticator({
    force: shouldReauthenticate,
    onError: handleError,
  });

  const openSocialShareModal = useCallback(() => {
    dispatch(
      pushModal({
        name: 'SocialShare',
        params: {
          platform: 'youtube',
        },
      }),
    );
  }, [dispatch]);

  return (
    <YouTubeButton
      size="small"
      params={withAuthentication}
      disabled={authenticating}
      onClick={createChainedFunction(
        () => onDownloadPageAction('youtubeShare'),
        withAuthentication(openSocialShareModal),
      )}
    />
  );
};

export default YoutubePostButton;
